
import { requestApi } from '@library'
import { CommonList, AutoScriptMissionListPayload, TaskLogItem } from '@types'

// 获取系统任务列表
export function getAutoScriptMissionList (payload: AutoScriptMissionListPayload) {
  return requestApi<CommonList<TaskLogItem>>('GetAutoScriptMissionList', payload)
}
